import "react";
import { Button } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/ErrorLoadingRetry.tsx
var ErrorLoadingRetry = ({ onRetry }) => /* @__PURE__ */ jsxs("div", {
	className: "gap-x-xs text-color-critical inline-flex w-full items-center justify-center",
	children: [
		/* @__PURE__ */ jsx("span", { children: "There was a problem loading" }),
		" ",
		/* @__PURE__ */ jsx(Button, {
			onClick: onRetry,
			children: "Retry"
		})
	]
});
export { ErrorLoadingRetry };

//# sourceMappingURL=ErrorLoadingRetry.js.map